<template>
    <div id="report-overall">
        <div class="overall-content">
            <md-progress-bar md-mode="indeterminate" v-if="loading" />
            <div class="chart-container">
                <div class="header">
                    <FilterTool v-model="filters" :isGraphShowing="true" :keep-state-on-query-params="true" />
                </div>
                <div class="chart-section">
                    <h2>{{ $t("report.overall") }}</h2>
                    <ChatCountChart :data="graphData" v-if="graphData" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.ratingOverall") }}</h2>
                    <RatingChart :data="graphData" v-if="graphData" />
                </div>
                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.chatbotSessionDurationOverall") }}</h2>
                    <SessionDurationChart :data="graphData" v-if="graphData" />
                </div>

                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.trainingOverall") }}</h2>
                    <TrainingChart :data="graphData" v-if="graphData" />
                </div>

                <a-divider />
                <div class="chart-section">
                    <h2>{{ $t("report.segmentsOverall") }}</h2>
                    <SegmentChart title="User Segmentation" :data="graphData" v-if="graphData" :segments="segments" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SideMenuBar from "../../SideMenuBar.vue";
import FilterTool from "../archive/FilterTool.vue";
import moment from "moment";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import RatingChart from "./charts/RatingChart.vue";
import SessionDurationChart from "./charts/SessionDurationChart.vue";
import TrainingChart from "./charts/TrainingChart.vue";
import ChatCountChart from "./charts/ChatCountChart.vue";
import SegmentChart from "./charts/SegmentChart.vue";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import ChatbotMenu from "../../ChatbotMenu.vue";

const log = log2("Overall");
export default {
    name: "Overall",
    components: {
        ChatbotMenu,
        SegmentChart,
        ChatCountChart,
        TrainingChart,
        SessionDurationChart,
        RatingChart,
        FilterTool,
        SideMenuBar,
    },
    data: function () {
        return {
            filters: {
                period: this.$route.query.period || "today",
                integration: this.$route.query.integration || null,
                storyId: this.$route.query.storyId || null,
                startDate: this.$route.query.startDate || moment().startOf("day").toISOString(),
                endDate: this.$route.query.endDate || moment().endOf("day").toISOString(),
            },
            graphData: null,
            segments: [],
            loading: true,
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            listSegments: "CB/listSegments",
        }),
        onChange(pagination, filters, sorter, extra) {
            console.log("params", pagination, filters, sorter, extra);
        },
        fetchConversationsDebounced(delay = 250) {
            if (this.lastTimerId) {
                clearTimeout(this.lastTimerId);
            }
            const timerId = setTimeout(() => {
                this.fetchConversations();
            }, delay);
            this.lastTimerId = timerId;
        },
        fetchConversations() {
            this.loading = true;
            if (!this.filters.period) {
                this.filters.period = "today";
            }
            if (this.filters.period !== "custom") {
                this.filters.startDate = null;
                this.filters.endDate = null;
                this.$router.replace({
                    query: {
                        period: this.filters.period,
                        integration: this.filters.integration,
                        storyId: this.filters.storyId,
                    },
                });
            }
            CHATBOT_API.REPORT.overall({ ...this.filters })
                .then(async (res) => {
                    this.graphData = res.data;
                    log("fetched data", this.graphData);

                    log("this.graph", this.graphData);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.listStories();
        this.listSegments().then((segments) => {
            this.segments = segments;
        });
        this.fetchConversationsDebounced();
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.reports.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        filters: {
            handler(newVal) {
                if (newVal !== undefined) {
                    log("filters changed", this.filters);
                    const date = new Date();
                    if (newVal.period === "today" || newVal.period === "yesterday") {
                        if (newVal.period === "today") this.datePeriod = moment().hour() + 1;
                        if (newVal.period === "yesterday") this.datePeriod = 24;
                    } else if (
                        newVal.period === "last-3-month" ||
                        newVal.period === "this-year" ||
                        newVal.period === "last-year"
                    ) {
                        if (newVal.period === "last-3-month") this.datePeriod = 3;
                        if (newVal.period === "this-year") this.datePeriod = date.getMonth() + 1;
                        if (newVal.period === "last-year") this.datePeriod = 12;
                    } else {
                        if (newVal.period === "last7") this.datePeriod = 7;
                        else if (newVal.period === "last30") this.datePeriod = 30;
                        else if (newVal.period === "this-month") this.datePeriod = date.getDate();
                        else if (newVal.period === "last-month")
                            this.datePeriod = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
                    }
                    this.fetchConversationsDebounced();
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-overall {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                h2 {
                    text-align: center;
                    font-weight: 700;
                    font-size: 40px;
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>
